// A rendezvény belépési listájának (PDF) letöltése: a szerver base64-ben adja a PDF-et, a böngésző fájlként menti.
// (A PDF két részből áll: a belépőkódok, majd a nevek ABC-sorrendjében; lásd api/classes/BelepesiLista.php.)
export function belepesiListaLetoltese(callAPI, rendezvenyID, kesz) {
    callAPI('General.getBelepesiLista', { rendezvenyID: rendezvenyID }, function (resp) {
        try {
            const bin = window.atob(resp.data.pdf);
            const bajtok = new Uint8Array(bin.length);
            for (let i = 0; i < bin.length; i++) {
                bajtok[i] = bin.charCodeAt(i);
            }
            const url = window.URL.createObjectURL(new Blob([bajtok], { type: 'application/pdf' }));
            const link = document.createElement('a');
            link.href = url;
            link.download = resp.data.fajlnev || 'belepesi_lista.pdf';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.setTimeout(function () { window.URL.revokeObjectURL(url); }, 10000);
        } finally {
            if (kesz) { kesz(); }
        }
    }, function () {
        if (kesz) { kesz(); }
    });
}
